import { req } from '../../@api/request';
import axios from 'axios';
export default class MapService {
  static controller: any;

  static List = async (
    swLat: number,
    swLng: number,
    neLat: number,
    neLng: number,
    level: number,
  ) => {
    const result = await req.get(
      `/map/markers?swLat=${swLat}&swLng=${swLng}&neLat=${neLat}&neLng=${neLng}&level=${level}`,
    );
    return result.data;
  };

  static officialPrice = async (address: string) => {
    const result = await req.get(`/map/polygon3?address=${address}`);
    return result.data;
  };

  // static poly = async (address: string, type: string) => {
  //   const result = await req.get(
  //     `/map/markers/analysis?addr=${address}&type=${type}`,
  //   );
  //   return result.data;
  // };

  static deal = async (address: string, type: string) => {
    const result = await req.get(
      `/map/markers/deal?type=${type}&address=${address}`,
    );
    return result.data;
  };

  static markerList = async (
    type: string,
    propertyType: string,
    startDate: string,
    endDate: string,
    minPrc: number,
    maxPrc: number,
    minDeposit: number,
    maxDeposit: number,
    minMonthlyRent: number,
    maxMonthlyRent: number,
    swLat: number,
    swLng: number,
    neLat: number,
    neLng: number,
    zoomlevel: number,
  ) => {
    // 기본 URL
    let url = `/map/markers/list?type=${type}&propertyType=${propertyType}&startDate=${startDate}&endDate=${endDate}&swLat=${swLat}&swLng=${swLng}&neLat=${neLat}&neLng=${neLng}&zoom=${zoomlevel}`;

    if (type.includes('A') || type.includes('B') || type.includes('C')) {
      url += `&minPrc=${minPrc}&maxPrc=${maxPrc}`;
    }
    // propertyType에 'D'가 포함되면 minDeposit, maxDeposit 추가
    if (type.includes('D')) {
      //월세 5000만원 이상을 구현하기위하여 월세의 최소금액이 5000만원일 때 월세의 최대금액을 1,000억으로 설정
      if (minMonthlyRent === 50000000) {
        maxMonthlyRent = 100000000000;
      }

      //보증금 30억원 이상을 구현하기위하여 보증금의 최소금액이 30억원일 때 보증금의 최대금액을 1,000억으로 설정
      if (minDeposit === 50000000) {
        maxDeposit = 100000000000;
      }

      url += `&minDeposit=${minDeposit}&maxDeposit=${maxDeposit}&minMonthlyRent=${minMonthlyRent}&maxMonthlyRent=${maxMonthlyRent}`;
    }

    const result = await req.get(url);
    return result.data;
  };

  static makerDetail = async (type: string, iidx: number) => {
    if (MapService.controller) {
      MapService.controller.cancel('Component unmounted');
    }
    const source = axios.CancelToken.source();
    MapService.controller = source;
    const result = await req.get2(`/map/markers/${type}/${iidx}`, {
      cancelToken: MapService.controller.token,
    });

    // const result = await req.get(`/map/markers/${type}/${iidx}`);

    return result.data;
  };

  static makerDetail2 = async (
    type: string,
    iidx: number,
    itemCode: string,
    status: string,
    specialCondition: string,
    specialItems: string,
    filterType: string,
  ) => {
    if (MapService.controller) {
      MapService.controller.cancel('Component unmounted');
    }
    const source = axios.CancelToken.source();
    MapService.controller = source;
    const result = await req.get2(
      `/map/markers2/${type}/${iidx}?type=${filterType}&itemCode=${itemCode}&status=${status}&specialCondition=${specialCondition}&specialItems=${specialItems}`,
      {
        cancelToken: MapService.controller.token,
      },
    );

    // const result = await req.get(`/map/markers/${type}/${iidx}`);

    return result.data;
  };

  static realDealDataArea = async (
    type: string,
    iidx: number,
    saleType: string,
  ) => {
    const result = await req.get(
      `/map/markers/deal/${type}/${iidx}?saleType=${saleType}`,
    );
    return result.data;
  };

  static realDealList = async (
    type: string,
    iidx: number,
    saleType: string,
    yearType: string,
    area: number,
  ) => {
    const result = await req.get(
      `/map/markers/deal/list/${type}/${iidx}?saleType=${saleType}&yearType=${yearType}&area=${area}`,
    );
    return result.data;
  };

  static moveSubMarker = async (
    code: string,
    type: string,
    propertyType: string,
    startDate: string,
    endDate: string,
    minPrc: number,
    maxPrc: number,
    minDeposit: number,
    maxDeposit: number,
    minMonthlyRent: number,
    maxMonthlyRent: number,
  ) => {
    let url = `map/markers/${code}/sub-marker?type=${type}&propertyType=${propertyType}&startDate=${startDate}&endDate=${endDate}`;
    if (type.includes('A') || type.includes('B') || type.includes('C')) {
      url += `&minPrc=${minPrc}&maxPrc=${maxPrc}`;
    }
    // propertyType에 'D'가 포함되면 minDeposit, maxDeposit 추가
    if (type.includes('D')) {
      //월세 5000만원 이상을 구현하기위하여 월세의 최소금액이 5000만원일 때 월세의 최대금액을 1,000억으로 설정
      if (minMonthlyRent === 50000000) {
        maxMonthlyRent = 100000000000;
      }

      //보증금 30억원 이상을 구현하기위하여 보증금의 최소금액이 30억원일 때 보증금의 최대금액을 1,000억으로 설정
      if (minDeposit === 50000000) {
        maxDeposit = 100000000000;
      }

      url += `&minDeposit=${minDeposit}&maxDeposit=${maxDeposit}&minMonthlyRent=${minMonthlyRent}&maxMonthlyRent=${maxMonthlyRent}`;
    }

    const result = await req.get(url);
    return result.data;
  };

  static regionList = async (region: string) => {
    const result = await req.get(`/map/region?code=${region}`);
    return result.data;
  };

  static currentLocation = async (
    swLat: number,
    swLng: number,
    neLat: number,
    neLng: number,
  ) => {
    const result = await req.get(
      `/map/location?swLat=${swLat}&swLng=${swLng}&neLat=${neLat}&neLng=${neLng}`,
    );
    return result.data;
  };
  static getRegionList = async (params: {
    regionCode: string;
    swLat: number;
    swLng: number;
    neLat: number;
    neLng: number;
    type?: string;
    itemCode?: string;
    status?: string;
    specialCondition?: string;
    specialItems?: string;
    sort?: string;
    name?: string;
  }) => {
    const result = await req.get('/map/list/region', {
      params: {
        regionCode: params.regionCode,
        swLat: params.swLat,
        swLng: params.swLng,
        neLat: params.neLat,
        neLng: params.neLng,
        type: params.type || '',
        itemCode: params.itemCode || '',
        status: params.status || '',
        specialCondition: params.specialCondition || '',
        specialItems: params.specialItems || '',
        sort: params.sort || '',
        name: params.name || '',
      },
    });

    return result.data;
  };
}
